<p-panel>
    <div class="d-flex justify-content-left align-content-center">
      <div>
        <h4 *ngIf="flag === 'edit'">{{headerTitleWhenEdit}}</h4>
        <h4 *ngIf="flag === 'new'">{{headerTitleWhenNew}}</h4>
      </div>
    </div>
    <div class="row">
      <div class="mb-5 col-sm-12">
        <app-form-builder
          [model]="model"
          [distributionColumns]="4"
          (selectAllcheck)="selectAll()"
          [fields]="formFieldsPlaces"
          (formChanges)="formChanges($event)">
        </app-form-builder>
      </div>
    </div>
    @switch(model.tipo_ecorregimen) {
      @case('Leñosos'){
        <div class="row">
          <div class="mb-5 col-sm-12">
            <h5>Cubiertas Vegetales Espontáneas o Sembrada</h5>
            <app-form-builder
              [model]="model"
              [distributionColumns]="4"
              (selectAllcheck)="selectAll()"
              [fields]="formFields"
              (formChanges)="formChanges()">
            </app-form-builder>
          </div>
        </div>
        <div class="row">
          <div class="mb-5 col-sm-12">
            <h5>Cubiertas Inertes (Restos Poda)</h5>
            <app-form-builder
              [model]="model"
              [distributionColumns]="3"
              (selectAllcheck)="selectAll()"
              [fields]="formFieldsCubiertasInertes"
              (formChanges)="formChanges()">
            </app-form-builder>
          </div>
        </div>
      }
      @case('Pastoreo') {
        <div class="row">
          <div class="mb-5 col-sm-12">
            <div class="d-flex flex-row justify-content-between align-items-center mb-3">
              <h5>Pastoreo Extensivo</h5>
              <button class="btn btn-primary" (click)="showDialogUploadFile = true">{{ optionsUploadFile.uploaded ? 'Ver Archivo' : 'Subir Archivo' }}</button>
            </div>
            <app-form-builder
              [model]="model"
              [distributionColumns]="3"
              (selectAllcheck)="selectAll()"
              [fields]="formFieldsPastoreoExtensivo"
              (formChanges)="formChanges()">
            </app-form-builder>
          </div>
        </div>

        <div class="row">
          <div class="mb-5 col-sm-12">
            <h5>Pastoreo Siega Sostenible / Islas de Biodiversidad </h5>
            <app-form-builder
              [model]="model"
              [distributionColumns]="3"
              (selectAllcheck)="selectAll()"
              [fields]="formFieldsPastoreoIslasBiodiversidad"
              (formChanges)="formChanges()">
            </app-form-builder>
          </div>
        </div>
        <small>
          3 cortes al año en explotaciones con más del 50% de pasto en altitud igual o inferior a 300 metros.
          <br>
          2 cortes al año en explotaciones de pasto con altitud mayor de 300 metros.
        </small>
      }
      @case('Arroz'){
        <div class="mb-5 col-sm-12">
          <h5>Ecorregímenes Arroz</h5>
          <app-form-builder
            [model]="model"
            [distributionColumns]="3"
            (selectAllcheck)="selectAll()"
            [fields]="formFieldsArroz2"
            (formChanges)="formChanges()">
          </app-form-builder>
          <app-dictado
          mensaje="Grabar observaciones" 
          [observaciones]="model.observaciones ?? ''" 
          (sendObservaciones)="getObservaciones($event)"
          ></app-dictado>
        </div>
      }
      @default {
        <div class="mb-5 col-sm-12"></div>
      }
    }
    
    <div class="d-flex justify-content-center mt-5">
      <div>
        <button class="btn btn-dark mx-2" (click)="goBack()">Volver</button>
      </div>
      <app-request-button
              (click)="submit()"
              [lockOnSuccess]="true"
              [mode]="requestButtonType"
              [request]="request">
      </app-request-button>
    </div>
  </p-panel>

  <app-upload-file [showUploadDialog]="showDialogUploadFile"  [options]="optionsUploadFile" (eventClose)="showDialogUploadFile = false" (eventUpload)="handleEventUpload($event)"></app-upload-file>